import * as React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Hero from '../components/Hero/Hero';
import FullpageScroll from '../components/FullpageScroll/FullpageScroll';
import Metrics from '../components/Metrics/Metrics';
import Tasks from '../components/Tasks/Tasks';
import Focus from '../components/Focus/Focus';
import Info from '../components/Info/Info';
import Testimonials from '../components/Testimonials/Testimonials';
import Tools from '../components/Tools/Tools';
import Articles from '../components/Articles/Articles';
import CTA from '../components/CTA/CTA';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Hero />
    <FullpageScroll />
    <Metrics />
    <Tasks />
    <Focus />
    <Info />
    <Testimonials />
    <Tools />
    <Articles />
    <CTA />
  </Layout>
);

export default IndexPage;
